import { render } from "./manage-drivers.vue?vue&type=template&id=15653dd0&scoped=true"
import script from "./manage-drivers.vue?vue&type=script&lang=js"
export * from "./manage-drivers.vue?vue&type=script&lang=js"

import "./manage-drivers.vue?vue&type=style&index=0&id=15653dd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15653dd0"]])

export default __exports__